module.exports = __webpack_public_path__ + "static/media/col-1-img.be1e1ba4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/BetaLandingPage/col-1-img.png
// module id = 194
// module chunks = 0